import * as React from 'react';
import { Spinner } from 'react-bootstrap';

export interface LoaderProps {
    loading: boolean;
    children?: any;
    showTextLoading?: boolean;
    customText?: string;
}

const Loader: React.FC<LoaderProps> = (props) => {
    let { children, loading, showTextLoading, customText } = props;

    Loader.defaultProps = {
        showTextLoading: false
    }

    if (loading) {
        return (
            <>
                {!showTextLoading &&
                    <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                }
                {showTextLoading &&
                    <>
                        <p><b>{customText ? customText : "Loading..."}</b></p>
                    </>
                }
            </>
        )
    }
    else if (children) {
        return <>{children}</>
    }
    else {
        return null;
    }
}

export { Loader }